import { Box, Paper, SxProps, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface DataLayoutProps {
  title: string;
  children: ReactNode;
  titleIcon?: React.ReactElement;
  action?: React.ReactElement;
  sx?: SxProps;
  bgVariant?: "transparent" | "filled";
}

export const DataLayout: React.FC<DataLayoutProps> = ({
  title,
  children,
  titleIcon,
  action,
  sx,
  bgVariant = "transparent",
}) => {
  return (
    <Paper
      data-background-elevation={1}
      variant="outlined"
      sx={{ overflow: "hidden", width: "100%", ...sx }}
    >
      <Box
        bgcolor={bgVariant === "filled" ? "action.hover" : "transparent"}
        sx={{
          px: 1.5,
          py: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "action.hover",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle2">{title}</Typography>
          {titleIcon && titleIcon}
        </Box>
        {action && action}
      </Box>

      {children}
    </Paper>
  );
};
